import type { DOMAttributes } from 'react';
import { forwardRef } from 'react';
import type { GridRenderEditCellParams } from '@mui/x-data-grid-pro';
import { useGridApiContext } from '@mui/x-data-grid-pro';

import SelectUnit from './SelectUnit';

import { useUnitOptions } from '../../../../../hooks/useUnitOptions';

type Props = GridRenderEditCellParams<never, string> &
  Pick<
    DOMAttributes<HTMLDivElement>,
    | 'onBlur'
    | 'onFocus'
    | 'onMouseLeave'
    | 'onMouseOver'
    | 'onTouchEnd'
    | 'onTouchStart'
  > & {
    org: string;
  };

const ImportUnitAutocomplete = forwardRef((params: Props, ref) => {
  const apiRef = useGridApiContext();

  const { data: unitsData, isLoading } = useUnitOptions();

  const {
    id,
    org,
    value,
    error: validationError,
    disabled,
    field,
    onBlur,
    onFocus,
    onMouseLeave,
    onMouseOver,
    onTouchEnd,
    onTouchStart,
  } = params;

  return (
    <SelectUnit
      ref={ref}
      error={validationError}
      id={id?.toString()}
      value={value}
      disabled={disabled || !org}
      options={unitsData || []}
      loading={isLoading}
      onChange={(newValue) => {
        apiRef.current?.setEditCellValue({
          id,
          field,
          value: newValue,
          debounceMs: 200,
        });
      }}
      inputSx={{
        padding: 0,
        margin: 0,
      }}
      onBlur={onBlur}
      onFocus={onFocus}
      onMouseLeave={onMouseLeave}
      onMouseOver={onMouseOver}
      onTouchEnd={onTouchEnd}
      onTouchStart={onTouchStart}
    />
  );
});

export default ImportUnitAutocomplete;
